/**
 * The catalog taxonomy without the catalog data.
 *
 * Client search UI needs these stable identifiers to validate and group API results,
 * but importing `site-catalog.ts` would also ship more than 10,000 citation styles.
 * Keep this module dependency-free so it is safe on either side of the network.
 */
export const CATALOG_TYPES = [
  "core",
  "style-landing",
  "style",
  "style-directory",
  "style-examples",
  "style-format",
  "style-in-text",
  "style-annotated-bibliography",
  "style-reference-page",
  "tool",
  "tool-collection",
  "guide",
  "guide-category",
  "how-to-cite",
  "comparison",
  "converter",
  "field",
  "region",
  "category",
  "cheat-sheet",
  "glossary",
] as const;

export type CatalogType = (typeof CATALOG_TYPES)[number];

const CATALOG_TYPE_SET = new Set<string>(CATALOG_TYPES);

export function isCatalogType(value: unknown): value is CatalogType {
  return typeof value === "string" && CATALOG_TYPE_SET.has(value);
}
